require(['knockout'], function (ko) {
	ko.bindingHandlers.stopBinding = {
		init: function () {
			return { controlsDescendantBindings: true };
		}
	};

	ko.virtualElements.allowedBindings.stopBinding = true;
});

define("v3/Common/Bindings/StopBinding.Binding", function(){});

